<template>
    <div class="page" v-show="isDisplay && files.length > 0" @click="isDisplay = false">
        <div class="content" :style="{ 'background-image': 'url(' + files[current] + ')' }"></div>
        <div class="controls">
            <Icon class="left" type="ios-arrow-forward" :class="{ invalid: current === 0 }" @click.stop="onChangeCurrent(-1)" />
            <Icon class="right" type="ios-arrow-forward" :class="{ invalid: current === files.length - 1 }" @click.stop="onChangeCurrent(1)" />
            <!-- <div class="left liefeng-icon liefeng-icon-arrow-right-bold" ></div>
            <div class="right liefeng-icon liefeng-icon-arrow-right-bold" :class="{ invalid: current === files.length - 1 }" @click.stop="onChangeCurrent(1)"></div> -->
        </div>
        <div class="indicate">
            <div class="item" v-for="(item, index) in files.length" :key="index" :class="{ current: current === index }" @click.stop="current = index"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 是否显示
            isDisplay: false,
            // 文件列表
            files: [],
            // 当前索引
            current: 0,
        }
    },

    methods: {
        display(url, urls = [url]) {
            if (url instanceof Array) {
                urls = url
                this.current = 0
            } else {
                let idx = urls.indexOf(url)
                this.current = idx === -1 ? 0 : idx
            }

            if (!urls || urls.length === 0) return console.error("urls is empty")

            this.files = urls
            this.isDisplay = true
        },

        /**
         * 切换当前索引
         */
        onChangeCurrent(step) {
            let _c = this.current + step

            if (_c < 0 || _c > this.files.length - 1) {
                return
            }

            this.current = _c
        },
    },
}
</script>

<style lang="less" scoped>
.page {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
        width: 80%;
        height: 80%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .controls {
        .left {
            position: absolute;
            top: calc(50% - 30px);
            left: 20px;
            font-size: 60px;
            color: #fff;
            cursor: pointer;
            transform: rotate(180deg);
        }

        .right {
            position: absolute;
            top: calc(50% - 30px);
            right: 20px;
            font-size: 60px;
            color: #fff;
            cursor: pointer;
        }

        .invalid {
            color: #8e8e8e;
            cursor: not-allowed;
        }
    }

    .indicate {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;

        .item {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #ededed;
            margin: 0 5px;
            cursor: pointer;

            &.current {
                background: #1f90ff;
            }
        }
    }
}
</style>
